const logoData = [
   {
      nama: "Jamang Susun 3",
      desc: "Melambangkan 3 rangkaian Raja Brawijaya sebagai awal (PKKMB), tengah (PBPK), dan akhir (OH) perjalanan sebagai mahasiswa baru, serta melambangkan Tri Dharma Perguruan Tinggi.",
      img: "jamang",
      id: 1
   },
   {
      nama: "Batik Kucecwara",
      desc: "Merupakan motif batik khas Malang yang merepresentasikan Universitas Brawijaya yang terletak di kota malang dan sebagai wujud harapan agar mampu meraih puncak kesuksesan.",
      img: "batik",
      id: 2
   },
   {
      nama: "Garuda Mungkur",
      desc: "Mahkota garuda mungkur sebagai perwujudan intelektual mahasiswa Universitas Brawijaya sebagai pionir pembawa perubahan",
      img: "garuda",
      id: 3
   },
   {
      nama: "Kerah",
      desc: "Melambangkan kegagahan dan kewibawaan",
      img: "kerah",
      id: 4
   },
   {
      nama: "Sumping",
      desc: "Sebagai perwujudan angkatan ke-59 Universitas Brawiaya yang bertanggung jawab serta memiliki kepekaan terhadap lingkungan sekitarnya",
      img: "sumping",
      id: 5
   },
   {
      nama: "Menoleh Kesamping",
      desc: "Sebagai lambang kebajikan dan masa depan",
      img: "menoleh",
      id: 6
   },
   {
      nama: "Topong Mahkota",
      desc: "Melambangkan angkatan ke-59Universitas Brawijaya yang berani bertanggung jawab.",
      img: "topong",
      id: 7
   },
]


export default logoData;